import {RefreshCw} from "lucide-react";
import React from "react";

export const LoadingSpinner = ({ size = 'medium', message = 'Loading...' }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <RefreshCw className={`${sizeClasses[size]} text-emerald-400 animate-spin`} />
      {message && (
        <p className="mt-3 text-white/60 text-sm">{message}</p>
      )}
    </div>
  );
};
